import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'


declareVrunComponent('visio2Participants', () => import('./components/Visio2Participants.vue'))



